// extracted by mini-css-extract-plugin
module.exports = {"image":"Kz-z","loaded":"Lz-z","placeholder":"Mz-z"};